module.exports = __webpack_public_path__ + "img/background.35d06c6.png";